import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Fade from '@mui/material/Fade';

const TimelinePanel = (props: React.PropsWithChildren) => {
    return (
        <FloatingEl>
            <Fade in>
                <Paper>{props.children}</Paper>
            </Fade>
        </FloatingEl>
    );
};

const FloatingEl = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    grid-column: sidebar-end / page-end;
    grid-row: timeline-top / timeline-bottom;
    justify-self: stretch;
    padding: 4px;
    min-width: 900px;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }

    @media (max-width: 1452px) {
        padding: 0 8px 8px 8px;
        grid-column: sidebar-start / page-end;
        justify-self: flex-start;
        width: calc(100%);
    }
`;

export default TimelinePanel;
